(function () {
    'use strict';

    angular
        .module('core.services')
        .service('PersonService', PersonService)

    /** @ngInject */
    function PersonService($q, HttpService) {
        const PersonService = {
            requestPasswordChange,
            getGenders,
            get,
            changePassword,
            getByParameters,
            getByDocument,
            getConsultants,
            getAssociationHistory,
            associateToCompany,
            updateCompanyAssociation,
            put,
            deleteCompanyAssociation
        }

        return PersonService;

        function requestPasswordChange(cpf) {
            return HttpService.get(`/people/documents/${cpf}/reset-password-request`);
        }

        function changePassword(changeData) {
            return HttpService.put('/people/change-password', changeData)
        }

        function getGenders() {
            let defer = $q.defer();

            const genders = [{
                Id: 1,
                Title: 'Feminino'
            }, {
                Id: 2,
                Title: 'Masculino'
            }];

            defer.resolve(genders);

            return defer.promise;
        }

        function get(personId) {
            return HttpService.get(`/people/${personId}`);
        }

        function getByParameters(params) {
            return HttpService.get('/people/by-parameters', {
                params
            });
        }

        function getByDocument(document) {
            return HttpService.get(`/people/documents/${document}`);
        }

        function getConsultants() {
            return HttpService.get('/people/consultants');
        }

        function getAssociationHistory(params) {
            return HttpService.get('/people/association-history', {
                params
            });
        }

        function associateToCompany(associationData) {
            return HttpService.post('/people/companies', associationData);
        }

        function updateCompanyAssociation(associationData) {
            return HttpService.put('/people/companies', associationData);
        }

        function put(personData) {
            return HttpService.put('/people', personData);
        }

        function deleteCompanyAssociation(personId, companyId) {
            return HttpService.delete(`/people/${personId}/companies/${companyId}`)
        }
    }
}());